import { render, staticRenderFns } from "./Kv.vue?vue&type=template&id=38130dd2"
import script from "./Kv.vue?vue&type=script&lang=js"
export * from "./Kv.vue?vue&type=script&lang=js"
import style0 from "./Kv.vue?vue&type=style&index=0&id=38130dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports